import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { PageLoading } from '@mkmp/core'
import { useAppStore } from './stores'
import { useAuth } from './hooks'
import { router } from './router'

function App() {
  const [loading, setLoading] = useState(true)
  const { initData } = useAppStore()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      initData()
    }

    setLoading(false)
  }, [])

  if (loading) {
    return <PageLoading />
  }

  return <RouterProvider router={router} />
}

export default App
